@if (visible) {
  <div
    class="sw-alert-backdrop"
    [class.sw-alert-closing]="closing"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'sw-alert-title'"
    (click)="onBackdropClick($event)"
  >
    <div class="sw-alert-box" [class.sw-alert-closing]="closing">

      <!-- Ícono de advertencia -->
      <div class="sw-alert-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
            fill="currentColor" opacity="0.15"
          />
          <path
            d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
            stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"
          />
          <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <circle cx="12" cy="17" r="0.5" fill="currentColor" stroke="currentColor" stroke-width="1.5"/>
        </svg>
      </div>

      <!-- Título -->
      <h2 class="sw-alert-title" id="sw-alert-title">{{ alert?.title }}</h2>

      <!-- Mensaje -->
      <p class="sw-alert-message">{{ alert?.message }}</p>

      <!-- Acciones -->
      <div class="sw-alert-actions">
        @if (!isAdmin) {
          <button class="sw-btn-upgrade" (click)="upgrade()" type="button">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                 stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
              <polyline points="17 6 23 6 23 12"/>
            </svg>
            Actualizar mi plan
          </button>
        }
        <button class="sw-btn-close" (click)="close()" type="button">
          Cerrar
        </button>
      </div>

    </div>
  </div>
}
